import { DiagnozaWizard } from "@/features/hca-diagnoza";
import { PublicShell } from "@/features/hca-public";
import { KontaktForm } from "@/features/hca-public/components/kontakt-form";
import type { ReactNode } from "react";

export function PublicShellWithDiagnoza({ children }: { children: ReactNode }) {
  return (
    <PublicShell
      diagnozaContent={<DiagnozaWizard variant="modal" />}
      kontaktContent={<KontaktForm />}
    >
      {children}
    </PublicShell>
  );
}
